import { render, staticRenderFns } from "./kiosk-layout.vue?vue&type=template&id=105133fc&"
import script from "./kiosk-layout.vue?vue&type=script&lang=js&"
export * from "./kiosk-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports